import { render, staticRenderFns } from "./SendNewsTabs.vue?vue&type=template&id=a963014e"
import script from "./SendNewsTabs.vue?vue&type=script&lang=js"
export * from "./SendNewsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports